import artifact from '$houdini/artifacts/CreateInventoryOption'
import { MutationStore } from '../runtime/stores/mutation'

export class CreateInventoryOptionStore extends MutationStore {
	constructor() {
		super({
			artifact,
		})
	}
}
